import { Dispatch, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import endpoints from "@src/core/api/endpoints";
import { HttpClient } from "@src/core/api/http-client";
import { CreatorContext } from "@src/core/contexts/creator";
import { DropContext } from "@src/core/contexts/drop";
import { Offer } from "@src/core/models/offer";
import OfferDetails from "@src/components/offers/details";
import PageLayout from "@src/components/shared/page-layout";

interface OfferShowPageParams {
  id: string;
}

const OfferShowPage = (): JSX.Element => {
  const { id } = useParams<OfferShowPageParams>();
  const [offer, setOffer] = useState<Offer>();
  const { drop, dropIsActive, dropIsExpired } = useContext(DropContext);
  const { creator } = useContext(CreatorContext);

  console.log(creator);

  useEffect(() => findOffer(id, setOffer), [id]);

  return (
    <PageLayout>
      <>
        {offer && creator && (
          <OfferDetails
            creator={creator}
            drop={drop}
            dropIsActive={dropIsActive}
            dropIsExpired={dropIsExpired}
            offer={offer}
          />
        )}
      </>
    </PageLayout>
  );
};

const findOffer = (id: string, setOffer: Dispatch<Offer>): void => {
  HttpClient.get<Offer>(endpoints.offersFind(id), (response) => {
    setOffer(response);
  }).catch((e) => console.log(e));
};

export default OfferShowPage;
